/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ArticleDialog.vue?vue&type=template&id=ba52f2ba"
import script from "./ArticleDialog.vue?vue&type=script&lang=js"
export * from "./ArticleDialog.vue?vue&type=script&lang=js"
import style0 from "./ArticleDialog.vue?vue&type=style&index=0&id=ba52f2ba&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba52f2ba')) {
      api.createRecord('ba52f2ba', component.options)
    } else {
      api.reload('ba52f2ba', component.options)
    }
    module.hot.accept("./ArticleDialog.vue?vue&type=template&id=ba52f2ba", function () {
      api.rerender('ba52f2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/articles/ArticleDialog.vue"
export default component.exports